import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import TourismPrimaryDialog from '../json-pages/TourismPrimaryDialog';

const UI = ({ match }) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Route path={`${match.url}/primary`} component={TourismPrimaryDialog} />
      <Redirect to="/error" />
    </Switch>
  </div>
);
export default UI;
